import React, { useEffect } from "react";
import { Card, Table, Button, TableRow, TableBody, TableCell, Container, TableContainer } from '@mui/material';
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetCMSList, ResetGetCMSList } from "src/redux/actions/CMSActions";
import Loader from "src/components/Loader";

const CMS = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const CMSList = useSelector((state) => state.cms?.cms_list?.data?.data?.cms_list);
    const loadingSelector = useSelector((state) => state.cms.loading);

    useEffect(() => {
        dispatch(GetCMSList());

        return () => {
            dispatch(ResetGetCMSList())
        }
    }, [dispatch]);

    const handleView = (data) => {
        navigate(`/dashboard/cms/others/${data._id}`, { state: data })
    };

    return (
        <Page title="Content Management System">
            {loadingSelector ? <Loader /> : null}
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Content Management System"
                    links={[
                        { name: "Dashboard", href: "/dashboard/app" },
                        { name: "Content Management System" },
                    ]}
                />
                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    headLabel={[
                                        { id: 'c_no', label: 'Sr no.', alignRight: false },
                                        { id: 'c_team1vsteam2', label: 'Title', alignRight: false },
                                        { id: 'c_subtitle', label: 'Description', alignRight: false },
                                        { id: 'c_action', label: 'Actions', alignRight: false }
                                    ]}
                                />
                                <TableBody>
                                    {CMSList ?
                                        CMSList.map((data, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell component="th" scope="row"> {index + 1}.</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textTransform: "capitalize" }}> {data.title}</TableCell>
                                                    <TableCell component="th" scope="row" style={{ textTransform: "capitalize" }}>
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: data.content }}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <Button size="small" color="success" onClick={() => handleView(data)}> View </Button>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                        : ""
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                </Card>
            </Container>
        </Page>
    );
};

export default CMS;
